import {
    TDefaultTimeType,
    TLocalPickerValue,
    IDefaultValueOptions
} from "./IDateInput";

import format from "date-fns/format"
import parse from "date-fns/parse"
import isBefore from "date-fns/isBefore"
import isAfter from "date-fns/isAfter"
import sub from "date-fns/sub"
import add from "date-fns/add"

import { DATE_FORMAT, STRICT_TIME_REGEX, TIME_FORMAT } from "../../../../constants/formats";

/**
 * 
 * @param date 
 * @param time 
 * @param valueFormat 
 */
export const processValue = (
    date: string | undefined,
    time: string | undefined,
    valueFormat: "date" | "time" | "date-time"
): string | undefined => {
    const dateAsDate = date && parse(date, DATE_FORMAT, new Date());
    const timeAsDate = time && parse(time, TIME_FORMAT, new Date());

    if (!dateAsDate && !timeAsDate) {
        //  return;
    };

    if (valueFormat === "date-time" && dateAsDate && timeAsDate) {
        let newValue = resetTime(new Date());
        newValue = overwriteDatePartOfDate(newValue, dateAsDate);
        newValue = overwriteTimePartOfDate(newValue, timeAsDate);
        return newValue.toISOString();
    };

    if ((valueFormat === "date" && dateAsDate) || dateAsDate) {
        return format(dateAsDate, "yyyy-MM-dd");
    };

    if ((valueFormat === "time" && timeAsDate) || timeAsDate) {
        return format(timeAsDate, "HH:mm");
    };
};


export const valueToPickerValue = (value?: string): TLocalPickerValue => {
    try {

        if (!value) {
            return {};
        };


        if (RegExp(/^[0-2][0-9]:[0-5][0-9]/).test(value)) {
            return { time: value };
        };

        if (RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/).test(value)) {
            return { date: format(new Date(value), DATE_FORMAT) };
        };

        const valueAsDate = new Date(value);

        return {
            date: format(valueAsDate, DATE_FORMAT),
            time: format(valueAsDate, TIME_FORMAT)
        };

    } catch (error) {
        return {};
    };
};

export const valueToDate = (value?: string): Date | undefined => {
    try {
        if (value && RegExp(/^[0-2][0-9]:[0-5][0-9]/).test(value)) {
            return
        }
        return value ? new Date(value) : undefined
    } catch (error) {
        return
    }
};

interface IGetDefaultDateValueOptions {
    defaultTime?: string;
    hourRoundingValue?: number;
    minDate?: Date;
};

export const getDefaultDateValue = (reference: Date, options: IGetDefaultDateValueOptions): string | undefined => {
    let date = ensureFreshDateInstance(reference);
    if (date) {
        let time = date;
        if (options.defaultTime && RegExp(STRICT_TIME_REGEX).test(options.defaultTime)) {
            const [hour, minutes] = options.defaultTime.split(":").map(Number);
            time = resetTime(date);
            time.setHours(hour);
            time.setMinutes(minutes);
        } else {
            time = roundToNearestHour(time, options.hourRoundingValue);
        };

        if (options.minDate && (isBefore(time, options.minDate) || format(options.minDate, TIME_FORMAT) === format(time, TIME_FORMAT))) {
            date = add(date, { days: 1 }); // Add day if time is before reference
        };

        date = overwriteTimePartOfDate(date, time);
        if (date) {
            return date.toISOString()
        }
    };
};




/**
 * Override only date of date object
 */
export const overwriteDatePartOfDate = (date: Date, newDate: Date) => {
    date.setDate(newDate.getDate());
    date.setMonth(newDate.getMonth());
    date.setFullYear(newDate.getFullYear());
    return new Date(date);
};

/**
 * Override only time of date objects
 */
export const overwriteTimePartOfDate = (date: Date, newDate: Date) => {
    date.setHours(newDate.getHours());
    date.setMinutes(newDate.getMinutes());
    date.setMilliseconds(newDate.getMilliseconds());
    return new Date(date)
};

/**
 * Sets time part of date to 00:00:00:0000
 * @param date 
 */
export const resetTime = (date: Date) => {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return new Date(date)
};

/**
 * 
 * @param date 
 * @param hourRoundingValue 
 */
export const roundToNearestHour = (date: Date, hourRoundingValue: number = 1) => {
    date.setHours(date.getHours() + hourRoundingValue);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return new Date(date)
};




/**
 * Checks that date is not invalid
 */
export const isValidDate = (date?: Date) => date && !isNaN(date.getTime());

/**
 * Makes new date intance if input exsits and is valid
 */
export const ensureFreshDateInstance = (inputDate?: Date) => (inputDate && isValidDate(inputDate)) ? new Date(inputDate) : undefined
